import { apiClient } from '@/lib/api/client';
import { API_ENDPOINTS } from '@/lib/api/config';
import { resolveApiUrl } from '@/lib/api/resolve-url';

import type {
  CreateShelfRequest,
  Shelf,
  ShelfContainerAssignment,
  ShelfContainersListParams,
  ShelfStats,
  ShelvesListParams,
  UpdateShelfRequest
} from '../types';

const { SHELVES } = API_ENDPOINTS;

export const shelvesApi = {
  getAll: (params?: ShelvesListParams) =>
    apiClient.getPaginated<Shelf>(SHELVES.LIST, params),

  getById: (id: number) => apiClient.get<Shelf>(SHELVES.GET(id)),

  create: (data: CreateShelfRequest) =>
    apiClient.post<Shelf>(SHELVES.CREATE, data),

  update: (id: number, data: UpdateShelfRequest) =>
    apiClient.put<Shelf>(SHELVES.UPDATE(id), data),

  delete: (id: number) => apiClient.delete(SHELVES.DELETE(id)),

  getStats: () => apiClient.get<ShelfStats>(SHELVES.STATS),

  getContainers: (shelfId: number, params?: ShelfContainersListParams) =>
    apiClient.getPaginated<ShelfContainerAssignment>(
      SHELVES.CONTAINERS(shelfId),
      params
    ),

  exportCsv: async () => {
    const token =
      typeof window !== 'undefined' ? localStorage.getItem('auth_token') : null;
    // gitlab-advanced-sast-exclude -- resolveApiUrl() pins every request to the configured API origin and throws on anything else.
    const res = await fetch(resolveApiUrl(SHELVES.EXPORT), {
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: 'text/csv'
      }
    });
    if (!res.ok) throw new Error('Export failed');
    const blob = await res.blob();
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `shelves-export-${new Date().toISOString().slice(0, 10)}.csv`;
    a.click();
    URL.revokeObjectURL(url);
  }
};
